// 個人情報保護方針への同意状態に応じて送信ボタンの活性／非活性を切り替える
export const initPrivacyAgreement = () => {
  const checkbox = document.querySelector('.js-privacy-agreement');
  const submitBtn = document.querySelector('.js-submit-btn');

  if (!checkbox || !submitBtn) return;

  const toggleButton = () => {
    submitBtn.disabled = !checkbox.checked;
  };

  // 初期状態
  toggleButton();

  // チェック状態変更時
  checkbox.addEventListener('change', toggleButton);
};